import { lumi } from "@/lib/lumi"

export async function uploadFile(file: File) {
  const results = await lumi.tools.file.upload([file])
  const uploaded = Array.isArray(results) ? results[0] : results
  if (uploaded?.uploadError) throw new Error(uploaded.uploadError)
  const url = uploaded?.fileUrl
  if (!url) throw new Error("Upload did not return a file URL.")
  return url
}
